import { Component } from 'react';
import PropTypes from 'prop-types';
import ReactGA from 'react-ga';

const { object } = PropTypes;

/**
 * AnalyticsTracker
 *
 * This component is in charge of tracking
 * page view with Google Analythics
 */

class AnalyticsTracker extends Component {
  /**
   * PropTypes validation
   */
  static propTypes = {
    location: object.isRequired,
  };

  componentDidMount() {
    const { location } = this.props;
    this.sendPageChange(location.pathname);
  }

  componentDidUpdate(prevProps) {
    const { location } = this.props;
    if (location.pathname !== prevProps.location.pathname) {
      this.sendPageChange(location.pathname);
    }
  }

  sendPageChange(pathname) {
    ReactGA.set({ pathname });
    ReactGA.pageview(pathname);
  }

  render() {
    return null;
  }
}

export default AnalyticsTracker;



// WEBPACK FOOTER //
// ./src/components/AnalyticsTracker/index.js